import {faces} from '../api/faces';
import {store} from '../store';
import {isLoggedIn} from '../util/auth';

export function loadFrontendFaces() {

  return new Promise((resolve, reject) => {
    faces().then(res => res.data).then(data => {
      if (!data.ok) {
        alert(`Failed: ${data.err}`);
        reject(`${data.err}`);
      }
      let faces = data.faces.sort((f1,f2) => {
        let ln1=f1.person_name.split(' ').slice(-1)[0];
        let ln2=f2.person_name.split(' ').slice(-1)[0];
        return ln1.localeCompare(ln2)
      });
      faces = faces.map(elt => {
        if (!elt.images) return elt;
        elt.images = elt.images.sort((a,b) => a.orientation == 'front' ? -1 : 1);
        return elt;
      })
      store.commit('saveFrontendFaces', faces);
      resolve();
    }).catch((err) => {
      alert(`Server error: ${err}`);
      reject(err);
    })
  });
}


// WEBPACK FOOTER //
// ./src/util/faces.js